import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { QuizComponent } from './quiz/quiz.component';
import { SearchComponent } from './search/search.component';
import { TrackMyWorkoutComponent } from './track-my-workout/track-my-workout.component';
import { ChooseYourWorkoutComponent } from './choose-your-workout/choose-your-workout.component';
import { YourWorkoutPlanComponent } from './your-workout-plan/your-workout-plan.component';
import { YourRunningWorkoutPlanComponent } from './your-running-workout-plan/your-running-workout-plan.component';

const routes: Routes = [
  {path: 'home', component: HomeComponent},
  {path: 'quiz', component: QuizComponent},
  {path: 'search', component: SearchComponent},
  {path: 'choose-your-workout', component: ChooseYourWorkoutComponent},
  {path: 'your-workout-plan', component: YourWorkoutPlanComponent},
  {path: 'your-running-workout-plan', component: YourRunningWorkoutPlanComponent},
  {path: 'track-my-workout', component: TrackMyWorkoutComponent},
  {path: '**', redirectTo: 'home'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled'
    })],
  exports: [RouterModule]
})
export class AppRoutingModule { }